import { useNavigate, useLocation } from 'react-router';
import { Users } from 'lucide-react';
import { Loading } from '@/shared/ui';
import { SectionLayout } from '@/shared/ui/layout';
import { ToolBadge } from '@/shared/ui/ToolBadge';
import { FocusGroupsContent } from '@/features/focus-groups';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { ROUTES } from '@/shared/config/routes';
import { readFocusGroupsOrigin, isToolsOrigin } from '@/shared/utils/focusGroupsNavigation';
import { useTranslation } from 'react-i18next';

const FocusGroupsInternal = () => {
  const { t } = useTranslation('audiences');

  const navigate = useNavigate();
  const { state } = useLocation() as { state: unknown };
  // When the user reached Focus Groups from a Tools page, send them back to the
  // Tools homepage instead of the dashboard.
  const backTarget = isToolsOrigin(readFocusGroupsOrigin(state)) ? ROUTES.TOOLS_HUB : ROUTES.HOME;

  return (
    <div className="h-full overflow-y-auto px-4 py-4">
      <SectionLayout
        variant="detail"
        title={t('focusGroups.focusGroups')}
        subtitle={t('focusGroups.conductLiveInterviewsWithYour')}
        // eslint-disable-next-line i18next/no-literal-string -- a category id, not copy
        icon={<ToolBadge toolId="focus-group-agent" category="plan" icon={Users} size="xl" />}
        onBack={() => void navigate(backTarget)}
      >
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg bg-card">
          <FocusGroupsContent />
        </div>
      </SectionLayout>
    </div>
  );
};

export const FocusGroups = () => {
  const workspaceId = useCurrentWorkspaceId();
  if (!workspaceId) return <Loading />;
  return <FocusGroupsInternal />;
};
